import { useEffect } from 'react';
import { useKeyboardContext } from './KeyboardShortcutProvider';
import type { ShortcutDefinition } from './types';

export function useKeyboardShortcuts(definitions: ShortcutDefinition[], deps: unknown[] = []) {
  const { registerShortcut } = useKeyboardContext();

  useEffect(() => {
    const unsubs = definitions.map((d) => registerShortcut(d));
    return () => unsubs.forEach((u) => u());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerShortcut, ...deps]);
}
